import paymentTypes from './payment.types';

export const initialState = {
  payment_details: {}
};

const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case paymentTypes.SAVE_PAYMENT_DETAILS:
      return {
        ...state,
        payment_details: action.payload
      };
    default:
      return state;
  }
};

export default paymentReducer;
